import html from "./SurveyContainer.html"
import "../ProjectWarning.css"
import "../SurveyManager.js"
import "./SurveyModal.js"
import { Buffer } from 'buffer'
import { persistAnonymousSurveyResult, persistLinkSurveyResult, persistSurveyResult } from "../../../api/survey/surveyResult"
import { getSurvey } from "../../../api/survey/survey"
import getStepViewLogger from "../../../api/survey/surveyAnalytics"
import { getSurveyPlatforms } from '../../../helpers/surveyPlatformCompatibility';

var module = angular.module("ResearchKitApplicationModule");

module.component('surveyContainer', {
	template: html,
	bindings: {
		surveyReference: '<',
		updateDocumentTitle: "=",
		surveyCompletionModel: '<'
	},
	controller: 'surveyContainerController',
	controllerAs: 'vm'
});

module.controller("surveyContainerController", ["$scope", "surveyManagerFactory", "$translate",
	function ($scope, surveyManagerFactory, $translate) {
		var vm = this;

		function saveResults() {
			var result = vm.surveyManager.getResult();
			var completionAction = vm.surveyManager.getCompletionAction();

			function saveSurveyResult() {
				if (vm.surveyReference.linkIdentifier) {
					return persistAnonymousSurveyResult(vm.surveyReference.linkIdentifier, result);
				} else if (vm.surveyReference.linkKey) {
					return persistLinkSurveyResult(vm.surveyReference.linkKey, result);
				} else {
					return persistSurveyResult(result);
				}
			}

			return saveSurveyResult(result)
				.then(function (response) {
					$scope.finishAction = function (reason) {
						$scope.$emit("surveyFinished", reason, result, completionAction, response?.Url, response?.LinkIdentifier);
						$scope.$apply();
					};
				})
				.catch(function (error) {
					if (vm.surveyManager) {
						$scope.$emit("surveyFinished", "Failed");
						$scope.$apply();
					}
				});
		}

		function surveySaveFailed(error) {
			$translate('survey-submit-error').then(function (translatedValue) {
					alert(translatedValue);
				}).then(function () {
					$scope.$emit("surveyFinished", "Failed");
					vm.surveyManager = null;
					vm.platforms = null;
				});
		}

		function surveyFinished(reason) {
			if (reason === "Completed") {
				$scope.finishAction(reason);
			}
			else {
				$scope.$emit("surveyFinished", reason);
			}
			vm.surveyManager = null;
			vm.platforms = null;
		}

		var startSurvey = function (survey) {
			//Handles completed task link followup
			if (!survey.surveyTemplate && survey.Url && survey.LinkIdentifier) {
				$scope.$emit("surveyFinished", "Completed", null, null, survey.Url, survey.LinkIdentifier);
			}

			if (vm.updateDocumentTitle) {
				document.title = survey.SurveyDisplayName ? survey.SurveyDisplayName : survey.SurveyName;
			}

			var template = survey.surveyTemplate;
			vm.platforms = getSurveyPlatforms(template);
			if (vm.platforms.indexOf("Web") === -1) return;

			var restorationData;
			if (survey.restorationData) {
				try {
					var buffer = Buffer.from(survey.restorationData, 'base64');
					restorationData = JSON.parse(buffer)
				} catch (e) {
					console.warn("Unable to restore survey progress: " + e);
				}
			}

			vm.warningMessage = survey.WarningMessage;

			vm.closeWarning = function () {
				vm.warningMessage = null;
			}

			vm.surveyManager = surveyManagerFactory.createSurveyManager({
				surveyID: survey.SurveyID,
				participantID: survey.ParticipantID,
				surveySessionID: survey.SurveySessionID,
				template: template,
				taskID: survey.TaskID,
				templateVersion: survey.SurveyTemplateVersion,
				participantStateAudit: survey.ParticipantStateAudit,
				finishedCallback: surveyFinished,
				saveResultsCallback: saveResults,
				saveResultsErrorCallback: surveySaveFailed,
				restorationData: restorationData,
				followUp: survey.FollowUp,
				replaceResultID: survey.ReplaceResultID,
				expressionInputs: survey.ExpressionInputs,
				existingResult: survey.ExistingResult,
				event: survey.Event
			}, {
				mode: "Survey",
				isCoordinatorEntered: false,
				analyticsEnabled: true,
				storeProgress: vm.surveyReference.linkKey || vm.surveyReference.linkIdentifier ? false : true,
				linkSurvey: vm.surveyReference.linkKey || vm.surveyReference.linkIdentifier ? true : false,
				stepViewLogger: getStepViewLogger(vm.surveyReference)
			});

			vm.surveyManager.startSurvey();
		}

		this.$onChanges = function (changesObj) {
			if (changesObj.surveyCompletionModel && changesObj.surveyCompletionModel.currentValue) {
				startSurvey(changesObj.surveyCompletionModel.currentValue);
			}
			else if (changesObj.surveyReference && changesObj.surveyReference.currentValue) {
				var onError = function () {
					$scope.$emit("surveyFinished");
				}

				var surveyReference = changesObj.surveyReference.currentValue;
				getSurvey(surveyReference).then(function (result) {
					if (surveyReference.linkKey && !result.surveyTemplate) {
						$scope.$emit("surveyFinished", "Completed");
						if (result.Url) {
							window.location = result.Url;
						}
					}
					else {
						startSurvey(result);
					}
				}).catch(onError).finally(function () {
					$scope.$apply();
				});
			}
		};
	}]
);